<!--
/*******************************************************************************
*@ 컴포넌트명   : vtnManagePayees.vue
*@ 컴포넌트설명 : 베트남 타행 자주쓰는계좌등록
*@ 사용전문     : RBF0600C60 - 입출금계좌등록
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 2023.05.16   이가영   (베트남) CITAD 수취인 유효성 검사 변경
********************************************************************************/
-->
<template>
  <section>
    <div class="scroll">
      <article class="contents">
        <div class="form">
          <!-- 은행명 -->
          <div class="form-row">
            <div class="item-tit">
              {{ /*은행명*/ $t("MPRS-02-02-09-02") }}
              <sup class="point">*</sup>
            </div>
            <div class="item-desc">
              <div class="form-text-field search">
                <div class="input-text-field column-mq">
                  <input type="text" id="textfield1" class="form-control" :value.sync="bnkEngName" disabled placeholder />
                  <button class="btn sm inline search" @click="openPopup()">{{ /*조회*/ $t("MINQ-02-03-01-14") }}</button>
                </div>
              </div>
            </div>
          </div>
          <!-- 지점명 -->
          <div class="form-row">
            <input-text ref="lcalBnkBrnEngName" id="lcalBnkBrnEngName" :value.sync="lcalBnkBrnEngName" labelI18n="MPRS-02-02-02-06" placeholder="MPRS-02-02-02-06" localeCase3 />
          </div>
          <!-- 계좌번호 -->
          <div class="form-row">
            <input-text ref="inquryAcno" id="inquryAcno" :value.sync="inquryAcno" labelI18n="MPRS-02-02-09-04" placeholder="MPRS-02-02-09-04" required engCase2 :maxByte="20" />
            <div class="info info-etc" v-html="$t('MPRS-02-02-09-12', { 1: cncycd })"></div>
          </div>
          <!-- 예금주명 -->
          <div class="form-row">
            <input-text
              ref="inquryDpstrName"
              id="inquryDpstrName"
              :value.sync="inquryDpstrName"
              labelI18n="MPRS-02-02-19-05"
              placeholder="MPRS-02-02-09-06"
              required
              engCase3
              :maxByte="70"
            />
          </div>
          <!-- 계좌 별명 -->
          <div class="form-row" v-if="usePage == 'manage'">
            <input-text
              ref="inquryAcnAls"
              id="inquryAcnAls"
              :value.sync="inquryAcnAls"
              labelI18n="MPRS-02-02-19-07"
              placeholder="MPRS-02-02-09-08"
              required
              :maxByte="40"
              engCase6
            />
            <!-- <div
            class="info info-etc"
            >{{ /*※ 계좌별명은 영문기준 최대 12자리까지 입력 가능합니다.*/ $t("MPRS-02-02-15-14") }}</div>-->
          </div>
        </div>
        <div class="btn-area--full fixed">
          <button class="btn md gray" @click="goToPrev()">{{ /*뒤로*/ $t("MPRS-02-02-15-12") }}</button>
          <button class="btn md normal" @click="goToNext()" :class="prgsYN">{{ /*다음*/ $t("MPRS-02-02-15-13") }}</button>
        </div>
      </article>
    </div>

    <popup :opened.sync="opendPopup" :use-footer="true" :all-scroll="true" :btn-area-padding="true" title="MPAY-02-01-18-16">
      <template #content>
        <article class="contents">
          <div class="tabs --type3" id="tabs">
            <button v-for="(tab, index) in vtnTabs" class="tab-button active" :key="index" v-html="$t(tab)"></button>
          </div>
          <div>
            <div class="form nomargin-bottom mtop-24">
              <div class="form-row">
                <div class="item-tit">{{ $t(/*은행명 또는 은행코드*/ "MPAY-02-01-18-07") }}</div>
                <div class="item-desc">
                  <div class="form-text-field">
                    <div class="input-text-field">
                      <input-text id="searchWord" :value.sync="searchWord" placeholder="MDEP-01-01-04-16" alphaNumOnly toLowerCase :maxByte="40" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-row nomargin-bottom">
                <div class="btn-area">
                  <button class="btn lg inline nomargin-bottom" @click="citadInq()">{{ /*조회*/ $t("MINQ-02-03-01-14") }}</button>
                </div>
              </div>
            </div>
            <template v-if="!_.isEmpty(RBF0408F40.response.result) && searchFlag == true">
              <account-List :breakdownList="false" :accountList="true">
                <template #total-count>
                  <strong class="total-count">{{ /*합계*/ $t("MPRS-02-02-01-07") }} : {{ RBF0408F40.response.result.length }}</strong>
                </template>
                <template #account-list>
                  <div v-for="(data, i) in RBF0408F40.response.result" :key="i">
                    <div class="box-white -type4">
                      <div class="header" @click="citadClick(data)">
                        <div class="title">
                          {{ data.bnkNameCtnt }}
                          <i class="icon icon-arrow-m-right" />
                        </div>
                        <div class="desc">
                          <div class="account">{{ data.instiCdNo }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </account-List>
            </template>
            <template v-else-if="_.isEmpty(RBF0408F40.response.result) && searchFlag == true">
              <div class="empty">
                <div class="empty-img">
                  <i class="icon icon-opt-no" />
                </div>
                <strong class="empty-text">{{ /*조회 내역이 없습니다.*/ $t("MCOM-0000015") }}</strong>
              </div>
            </template>
            <template v-else></template>
            <div class="notice notice-box--type">
              <div class="notice-tit arrow">
                <p class="bullet">{{ /*유의사항*/ $t("MCOP-01-01-07-17") }}</p>
                <i class="icon icon-dropdown-m-arrow" @click="toggleShow" :class="{ rotate: show }" />
              </div>
              <div class="notice-cont" v-if="show">
                <ul class="ulist bar">
                  <li>- {{ $t("MPAY-02-01-18-11") }}</li>
                  <li>- {{ $t("MPAY-02-01-18-12") }}</li>
                  <li>- {{ $t("MPAY-02-01-18-10") }}</li>
                </ul>
              </div>
            </div>
          </div>
        </article>
      </template>
      <template #footer>
        <button class="btn md gray" @click="popupClose()">{{ /*닫기*/ $t("MPRS-02-02-03-02") }}</button>
        <button class="btn md normal" @click="use()" :class="changeClass()">{{ /*사용*/ $t("MFXD-01-01-11-09") }}</button>
      </template>
    </popup>
  </section>
</template>
<script>
import { mapFields } from "vuex-map-fields";
import AccountList from "@/components/page/customer/account.vue";

export default {
  computed: {
    ...mapFields(["sessionInfo"]),
  },
  components: {
    AccountList,
  },
  props: {
    usePage: {
      type: String,
    },
    cncycd: {
      type: String,
      required: true,
    },
  },
  watch: {
    bnkEngName: function() {
      this.validPrgs();
    },
    inquryAcno: function() {
      this.validPrgs();
    },
    inquryDpstrName: function() {
      this.validPrgs();
    },
    inquryAcnAls: function() {
      this.validPrgs();
    },
    lcalBnkBrnEngName: function() {
      this.validPrgs();
    },
  },
  data() {
    return {
      bnkEngName: "",
      inquryAcno: "",
      inquryDpstrName: "",
      mnrcvInfo: {
        mnrcvAcnAls: "",
        mnrcvAcno: "",
        mnrcvCncycd: "",
        mnrcvDpstrName: "",
        mnrcvOthrBnkName: "",
        mnrcvSerno: "",
        rcevnBnkIfscCode: "",
        mnrcvBrnName: "",
      },
      inquryAcnAls: "",
      RBF0600C60: {
        request: {},
        response: {},
      },
      validList: [],
      prgsYN: "disabled",

      //은행명 조회 관련
      opendPopup: false,
      vtnTabs: ["MPAY-02-01-18-06"],
      searchFlag: false,
      show: false,
      searchWord: "",
      tmpNapasBnkNo: "",
      tmpNapasBnkName: "",
      bnkNo: "",
      RBF0408F40: {
        request: {},
        response: {},
      },
      lcalBnkBrnEngName: "",
    };
  },
  methods: {
    validPrgs() {
      if (this.usePage == "manage") {
        if (
          this.$refs.inquryAcno != undefined &&
          this.$refs.inquryDpstrName != undefined &&
          this.$refs.inquryAcnAls != undefined &&
          this.$refs.lcalBnkBrnEngName != undefined
        ) {
          this.prgsYN =
            this.bnkEngName == "" ||
            this.$refs.inquryAcno.$v.$invalid ||
            this.$refs.inquryDpstrName.$v.$invalid ||
            this.$refs.inquryAcnAls.$v.$invalid ||
            this.$refs.lcalBnkBrnEngName.$v.$invalid
              ? "disabled"
              : "";
          this.$EventBus.$emit("vtnRegister", this.prgsYN);
        } else {
          this.prgsYN = "";
          this.$EventBus.$emit("vtnRegister", this.prgsYN);
        }
      } else {
        if (this.$refs.inquryAcno != undefined && this.$refs.inquryDpstrName != undefined && this.$refs.lcalBnkBrnEngName != undefined) {
          this.prgsYN =
            _.isEmpty(this.bnkEngName) || this.$refs.inquryAcno.$v.$invalid || this.$refs.inquryDpstrName.$v.$invalid || this.$refs.lcalBnkBrnEngName.$v.$invalid ? "disabled" : "";
          this.$EventBus.$emit("vtnRegister", this.prgsYN);
        } else {
          this.prgsYN = "";
          this.$EventBus.$emit("vtnRegister", this.prgsYN);
        }
      }
    },
    setInfo() {
      this.mnrcvInfo = {
        mnrcvAcnAls: "",
        mnrcvAcno: this.inquryAcno,
        mnrcvCncycd: this.cncycd,
        mnrcvDpstrName: this.inquryDpstrName,
        mnrcvOthrBnkName: this.bnkEngName,
        mnrcvSerno: "",
        rcevnBnkIfscCode: this.bnkNo,
        mnrcvBrnName: this.lcalBnkBrnEngName,
      };
      return this.mnrcvInfo;
    },
    goToPrev() {
      this.$router.push({ name: "managePayeesList", params: { currentTab: 1 } });
    },
    valid() {
      // this.validList = Object.keys(this.$refs);
      // for (let i = 0; i < this.validList.length; i++) {
      //   this.$refs[this.validList[i]].$v.$touch();
      // }
      // for (let i = 0; i < this.validList.length; i++) {
      //   if (this.$refs[this.validList[i]].$v.$invalid) {
      //     return false;
      //   }
      // }
      // return true;
      if (this.usePage == "manage") {
        this.$refs.inquryAcnAls.$v.$touch();
      }
      this.$refs.inquryAcno.$v.$touch();
      this.$refs.inquryDpstrName.$v.$touch();
      if (this.usePage == "manage") {
        if (this.$refs.inquryAcno.$v.$invalid || this.$refs.inquryAcnAls.$v.$invalid || this.$refs.inquryDpstrName.$v.$invalid || this.bnkEngName == "") {
          return false;
        }
      } else {
        if (this.$refs.inquryAcno.$v.$invalid || this.$refs.inquryDpstrName.$v.$invalid || _.isEmpty(this.bnkEngName)) {
          return false;
        }
      }
      return true;
    },
    goToNext() {
      // this.$refs.inquryAcnAls.$v.$touch();
      // this.$refs.inquryAcno.$v.$touch();
      // this.$refs.inquryDpstrName.$v.$touch();
      // this.$refs.bnkEngName.$v.$touch();
      // if (this.$refs.inquryAcno.$v.$invalid || this.$refs.inquryAcnAls.$v.$invalid || this.$refs.inquryDpstrName.$v.$invalid || this.$refs.bnkEngName.$v.$invalid) {
      //   return;
      // }
      if (this.valid()) {
        this.RBF0600C60Call();
      }
    },
    RBF0600C60Call() {
      this.RBF0600C60.request = {
        dmndPageNo: "00000",
        pageLineCnt: "00000",
        gridRowCnt: "00001",
        inquiryUserStupAcnDstcd1: "2", // 입출금계좌구분코드2 1:출금계좌, 2:입금계좌
        deviceType: "mobile",
        inDataGrid: [
          {
            inquryUserStupAcnDstcd2: "2", // 입출금계좌구분코드2 1:출금계좌, 2:입금계좌
            inquryAcno: this.inquryAcno, // 계좌번호
            inqurySerno: "1", // 일련번호
            inquryBrncoEcrypPwd: "", // 계좌비밀번호
            inquryAcnAls: this.inquryAcnAls, // 계좌별명
            inquryDpstrName: this.inquryDpstrName, // 예금주명
            inquryOthrBnkName: this.bnkEngName, // 타은행명
            inquryBrnName: this.lcalBnkBrnEngName, // 부점명
            inquryCncycd: this.cncycd, //통화코드
            inquryPrcssDstcd: "2", // 처리구분코드 1:출금계좌등록, 2:입금계좌등록, 5:계좌번호변경, 6:계좌번호해지
            inquryObaobDstcd: "2", // 당타행구분코드 1:당행, 2:타행
            rcevnBnkIfscCode: this.bnkNo,
          },
        ],
      };

      this.$post(
        "/customer/acn/MnrcyAcnRegiRes",
        this.RBF0600C60.request, //input값 요청할데이터
        this.RBF0600C60Suc, //호출 성공시 실행하는 콜백
      );
    },
    /* API_RBF0600C60 호출 성공 */
    RBF0600C60Suc(res) {
      this.RBF0600C60.response = res.outItem;
      this.$router.push({ name: "managePayeesList", params: { currentTab: 1 } });
    },

    /*베트남 팝업 관련*/
    openPopup() {
      this.opendPopup = true;
      this.show = true;
      this.searchFlag = false;
      this.searchWord = "";
      this.tmpNapasBnkNo = "";
      this.tmpNapasBnkName = "";
      this.citadInq();
    },
    toggleShow() {
      this.show = !this.show;
    },
    changeClass() {
      if (this.tmpNapasBnkNo == "") {
        return "disabled";
      } else {
        return "";
      }
    },
    popupClose() {
      this.opendPopup = false;
    },
    citadInq() {
      this.show = false;
      this.searchFlag = true;
      this.RBF0408F40Call();
    },
    citadClick(data) {
      this.tmpNapasBnkNo = data.instiCdNo;
      this.tmpNapasBnkName = data.bnkNameCtnt;
    },
    use() {
      this.bnkNo = this.tmpNapasBnkNo;
      this.bnkEngName = this.tmpNapasBnkName;

      this.confirm();
    },
    confirm() {
      this.brncoOtrbnkRmtancMdiaDstcd = "";
      this.opendPopup = false;
    },
    RBF0408F40Call() {
      this.RBF0408F40.request = {
        inquryBnkCtnt: this.searchWord,
      };
      this.$post("/customer/acn/CitadBnkListInquiry", this.RBF0408F40.request, this.RBF0408F40Suc);
    },
    RBF0408F40Suc(res) {
      this.RBF0408F40.response = res.outItem;
    },
  },
};
</script>
